export default __webpack_public_path__ + "static/media/dark.a98b6cef.jpg";